import { Box, Stack, Typography } from "@mui/material"
import React from "react"

const CheckoutHeader6 = () => {
  return (
    <Box position="absolute" left="0px" right="0px" top="0px" zIndex={1000}>
      <Stack
        sx={{
          py: 2,
          width: "100%",
          background: "linear-gradient(180deg, #364E9D, #21326A)",
          color: "white",
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          alignContent="center"
          justifyContent="center"
          sx={{ width: "100%" }}
        >
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            alignContent="center"
          >
            <Typography fontSize="20px" lineHeight="32px">
              <b>+30.000 downloads</b> a cada dia
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Box>
  )
}

export default CheckoutHeader6
